import { useState } from 'react';
import Slider from 'react-slick';
import { Collapse, Grid, Input } from 'antd';
import ImageC from 'src/components/Image';
import EmptyC from 'src/components/Layout/Empty';
import PaginationC from 'src/components/Layout/Pagination';
import { NextArrow, PrevArrow } from 'src/components/Layout/Slick/Arrow';
import { Title } from 'src/components/Layout/Typography';
import TagC from 'src/components/Tag';

import collapseClasses from '../../../components/AccordionContent/index.module.css';
import classes from './index.module.css';
import cn from "src/utils/cn";

const ROWPERPAGE = 10;

const ContainerPage = ({ topic, topicQuestions }: { topic: any; topicQuestions: any }) => {
	const { xs } = Grid.useBreakpoint();
	const paginatedItems = (list: any, page: number = 1, pageSize: number = ROWPERPAGE) => {
		const offset: number = (page - 1) * pageSize;
		return list.slice(offset).slice(0, pageSize);
	};

	var groupBy = function (array: any, key: any) {
		return array.reduce(function (rv: any, x: any) {
			(rv[x[key]] = rv[x[key]] || []).push(x);
			return rv;
		}, {});
	};

	const groupedQuestions = groupBy(topicQuestions, 'tab');
	const hasTabs =
		Object.keys(groupedQuestions)?.length === 1 &&
		Object.keys(groupedQuestions)?.[0] === 'undefined'
			? false
			: true;

	const [tab, setTab] = useState(Object.keys(groupedQuestions)[0]);
	const [searchKeyword, setSearchKeyWord] = useState('');
	const [paginationInfo, setPaginationInfo] = useState({ page: 1 });

	let questions: any[] = topicQuestions;
	if (Object.keys(groupedQuestions).length > 0) {
		questions = groupedQuestions[tab];
	}

	if (searchKeyword.length > 0) {
		const keywords = searchKeyword.trim().split(' ');
		questions = questions.filter((q: any) => {
			const allow: boolean = keywords.some((k: string) => {
				return q.title.toLowerCase().indexOf(k.toLowerCase()) > -1;
			});

			return allow;
		});
	}

	const totalRecords = questions?.length ?? 0;
	const totalPage = Math.ceil(totalRecords / ROWPERPAGE);

	questions = paginatedItems(questions, paginationInfo.page, ROWPERPAGE);

	const PanelTitle = (props: { title: string }) => {
		return <h2 className={collapseClasses['panel-title']}>{props.title}</h2>;
	};

	const IconExpandUp = () => {
		return <ImageC alt="Icon Arrow" height={6} width={10} src="/icons/arrow-chevron-up.svg" />;
	};

	const IconExpandDown = () => {
		return <ImageC alt="Icon Arrow" height={6} width={10} src="/icons/arrow-chevron-down.svg" />;
	};

	return (
		<>
			<div className={classes['page-body-wrap']}>
				<div className="container">
					<div className={classes['page-search-content']}>
						<div className={classes['page-content-head']}>
							<div className={classes['action-wrap']}>
								<div className={classes['topic-logo-wrap']}>
									<ImageC
										src={topic.iconUrl}
										alt="topic logo"
										width={xs ? 40 : 64}
										height={xs ? 40 : 64}
									/>
									<h1>{topic.title}</h1>
								</div>
								<Input.Search
									placeholder="Ketik yang Anda cari"
									enterButton
									name="keyword"
									className={classes['search-input']}
									value={searchKeyword}
									onChange={(e) => {
										setPaginationInfo({
											...paginationInfo,
											page: 1,
										});
										setSearchKeyWord(e.currentTarget.value);
									}}
								/>
							</div>
						</div>
						<div className={classes['page-content-body']}>
							{totalRecords <= 0 ? (
								<EmptyC
									image="/images/empty/medical-appointment.svg"
									title="Pertanyaan tidak ditemukan"
									description="Coba cek lagi nanti yah."
									buttonText=""
								/>
							) : (
								<>
									<div className={classes['search-list']}>
										{hasTabs && (
											<div
												className={cn(
													classes['tab-container'],
													{ [classes['responsive-mobile']]: xs },
													'mb-6',
												)}
											>
												{!xs ? (
													<Slider
														className={classes.slider}
														infinite={false}
														swipeToSlide={true}
														slidesToScroll={3}
														variableWidth={true}
														nextArrow={<NextArrow size={32} sizeArrow={16} />}
														prevArrow={<PrevArrow size={32} sizeArrow={16} />}
													>
														{Object.keys(groupedQuestions)?.map((qTab, i) => {
															return (
																<TagC
																	key={`${qTab}-${i}`}
																	type="chips"
																	tabIndex={i}
																	className={cn(
																		classes.tag,
																		classes['category-of-products'],
																		{ [classes.active]: qTab === tab },
																		'cursor-pointer',
																	)}
																	onClick={() => {
																		setPaginationInfo({
																			...paginationInfo,
																			page: 1,
																		});
																		setTab(qTab);
																	}}
																>
																	<Title
																		className={cn(
																			classes.text,
																			'mb-0 fs-12 fs-sm-16 text-center',
																		)}
																		level={3}
																		text={qTab}
																	/>
																</TagC>
															);
														})}
													</Slider>
												) : (
													<>
														{Object.keys(groupedQuestions)?.map((qTab, i) => {
															return (
																<TagC
																	key={`${qTab}-${i}`}
																	type="chips"
																	tabIndex={i}
																	className={cn(
																		classes.tag,
																		classes['category-of-products'],
																		{ [classes.active]: qTab === tab },
																		'cursor-pointer',
																	)}
																	onClick={() => {
																		setPaginationInfo({
																			...paginationInfo,
																			page: 1,
																		});
																		setTab(qTab);
																	}}
																>
																	<Title
																		className={cn(
																			classes.text,
																			'mb-0 fs-12 fs-sm-16 text-center',
																		)}
																		level={3}
																		text={qTab}
																	/>
																</TagC>
															);
														})}
													</>
												)}
											</div>
										)}

										<Collapse
											expandIconPosition="end"
											expandIcon={({ isActive }) => {
												if (!isActive) {
													return <IconExpandDown />;
												}
												return <IconExpandUp />;
											}}
											className={collapseClasses['collapse-membership']}
											bordered={false}
										>
											{questions?.map((content: any) => {
												return (
													<Collapse.Panel
														key={content.title}
														header={<PanelTitle title={content.title} />}
														className={collapseClasses['collapse-membership-item']}
													>
														<div
															className={classes['collapse-container']}
															dangerouslySetInnerHTML={{ __html: content.answer }}
														/>
													</Collapse.Panel>
												);
											})}
										</Collapse>
									</div>
									<PaginationC
										className={classes.pagination}
										defaultCurrent={paginationInfo?.page || 1}
										current={paginationInfo?.page}
										onChange={(currentPage: any) =>
											setPaginationInfo({
												...paginationInfo,
												page: currentPage,
											})
										}
										total={totalRecords}
										totalPage={totalPage}
									/>
								</>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ContainerPage;
